


















import { defineComponent } from '@vue/composition-api';
import { PropType, Prop } from 'vue/types/options';

import ChannelListData from '@/ts/Channels/ChannelListData';
import BrandButton from '@/components/NEW-STRUCTURE/mobile/buttons/BrandButton.vue';

export default defineComponent({
    components: { BrandButton },
    props: {
        channel: ChannelListData,
        userHasJoined: {
            required: false,
            type: Boolean,
            default: false,
        },
    }, 
    setup(props, { emit }) {
        function onChannelSelect() {
            emit('onChannelSelect');
        }

        function onChannelJoin() {
            emit('onChannelJoin');
        }

        return {
            onChannelSelect,
            onChannelJoin,
        };
    },
});
